import React from 'react'
import { App} from 'antd'
import { useHouduankaifaDelMutation } from '../../store/BnsKeJiApi';
import {DeleteOutlined,} from '@ant-design/icons';
function BackendDel(props) {
    const {modal,message} = App.useApp(); 
    const [submitDel] = useHouduankaifaDelMutation()   
    return (
        <>
            {localStorage.getItem('eu_id') === props.etul_uid &&<a onClick={() => {
                modal.confirm({
                    title: '确定删除吗?',
                    content: '删除后不能恢复',
                    okText: '确认',
                    okType: 'danger',
                    cancelText: '取消',
                    onOk() {
                        submitDel({etul_id:props.etul_id}).then((res) => {
                            // console.log(res);
                            if (res.data.Status === 'success') {
                                message.info('删除成功！');
                            }
                            if (res.data.Status === "fail") {
                                message.error('删除失败！'+res.data.Message)
                            }
                        })
                    },
                    onCancel() {
                        // console.log('Cancel');
                    },
                }); 
            }}><DeleteOutlined /> 删除任务</a>}
        </>
        
    )
}

export default BackendDel